import React, { memo, forwardRef } from "react";
const SvgParentheses = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M13.918 21.97c.653 2.032 1.516 3.814 2.591 5.345.241.341.548.544.92.544.284 0 .532-.1.731-.297a.922.922 0 00.306-.713c0-.232-.092-.476-.246-.726l-.002-.004c-.943-1.459-1.7-3.098-2.272-4.918a18.832 18.832 0 01-.828-5.503c0-1.851.276-3.686.828-5.503.571-1.82 1.329-3.46 2.272-4.918l.002-.004c.154-.25.246-.494.246-.726 0-.284-.1-.528-.306-.712a1.008 1.008 0 00-.731-.298c-.372 0-.678.202-.92.544-1.075 1.53-1.938 3.323-2.591 5.373a20.285 20.285 0 00-.982 6.244c0 2.127.328 4.218.982 6.271zm3.511-18.233z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgParentheses.displayName = "SvgParentheses";
const MemoForwardRef = memo(SvgParentheses);
export default MemoForwardRef;
